(function () {
  const cache = {};

  function resolveLocaleUrl(url, locale) {
    const code = (locale || 'es').split('-')[0].toLowerCase();
    if (!code || code === 'es') return url;
    if (new RegExp('\\.' + code + '\\.json', 'i').test(url)) return url;
    return url.replace(/\.json(\?.*)?$/, '.' + code + '.json');
  }

  async function loadData(url) {
    if (cache[url]) return cache[url];
    const res = await fetch(url);
    if (!res.ok) throw new Error('Why love fetch failed');
    cache[url] = await res.json();
    return cache[url];
  }

  async function loadLocalized(url, locale) {
    const localized = resolveLocaleUrl(url, locale);
    if (localized !== url) {
      try {
        const res = await fetch(localized);
        if (res.ok) {
          cache[localized] = await res.json();
          return cache[localized];
        }
      } catch (e) {}
    }
    return loadData(url);
  }

  function renderBullets(list, bullets) {
    list.replaceChildren();
    bullets.forEach((text) => {
      const li = document.createElement('li');
      li.className = 'product-why-love__item';
      li.textContent = text;
      list.appendChild(li);
    });
  }

  async function initBlock(block) {
    const handle = block.dataset.productHandle;
    const dataUrl = block.dataset.whyLoveUrl;
    const list = block.querySelector('[data-why-love-list]');
    if (!handle || !dataUrl || !list) return;

    try {
      const data = await loadLocalized(dataUrl, block.dataset.locale);
      const bullets = data[handle];
      if (!bullets || !bullets.length) {
        block.hidden = true;
        return;
      }
      renderBullets(list, bullets);
    } catch (e) {
      block.hidden = true;
    }
  }

  function boot() {
    document.querySelectorAll('.product-why-love[data-product-handle]').forEach(initBlock);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
